import ElaborazioneGiornoPage from "./ElaborazioneGiornoPage";

export default function ElaborazionePeriodoPage() {
  return <ElaborazioneGiornoPage forcedMode="periodo" />;
}
